import React from "react";
import "../Assets/css/index.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import influencerSliderComputer from ".././Assets/Img/influencer slider computer.png";
import influencerSliderRobot from ".././Assets/Img/influencer slider robot.png";
import influencerSliderUser from ".././Assets/Img/influencer slider user.png";
import roundbrand from ".././Assets/Img/roundbrand.png";
import brandpanel4 from ".././Assets/Img/brandpanel4.png";
import Growth from ".././Assets/Img/Growth.png";
import Efficiency from ".././Assets/Img/Efficiency.png";
import Metrics from ".././Assets/Img/Metrics.png";
import Transparency from ".././Assets/Img/Transparency.png";
import Access from ".././Assets/Img/Access.png";
import caseStudyy from ".././Assets/Img/case Study.png";
import { Button } from "react-bootstrap";

function Influencer() {
  const settings = {
    dots: false, // Disable dots
    arrows: false, // Disable arrows
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Automatically changes images
    autoplaySpeed: 2000, // Speed of transition (1000ms = 1 second)
    fade: true, // Enables fade effect instead of sliding
  };
  const marketsettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 5000, // Adjust speed for smooth continuous effect
    dots: false,
    arrows: false,
    pauseOnHover: false, // Prevents autoplay from stopping on hover
    pauseOnFocus: false, // Prevents autoplay from stopping on focus (e.g., clicking)
    cssEase: "linear", // Ensures continuous smooth scrolling
  };
  const benefits = [
    {
      title: "Benefit 1",
      description: "Description for benefit 1",
      icon: "bi bi-gear", // Example icon
    },
    {
      title: "Benefit 2",
      description: "Description for benefit 2",
      icon: "bi bi-heart", // Example icon
    },
    // Add other benefits as needed
  ];
  const stats = [
    {
      title: "200%",
      value: "578%",
      description:
        "2023 influencer campaigns drove 200% ROI for top-performing brands Influencer Marketing Hub)",
    },
    {
      title: "15% YoY",
      value: "",
      description:
        "Average CPM Cost per Mille) increased by 15% YoY, reflecting growing demand.",
    },
    {
      title: "70%",
      value: "",
      description:
        "70% of teens trust influencers more than traditional celebrities (EY Insights).",
    },
    {
      title: "135%",
      value: "",
      description:
        "Video content campaigns drive 135% more organic engagement than static posts.(Sprout Social).",
    },
  ];
  const cases = [
    {
      users: "15M+",
      usersText: "USERS PER MONTH",
      date: "Feb 2, 2025",
      title: "Myntra Studio",
      description: "How Myntra is using Influencers for its Growth",
    },
    {
      users: "15M+",
      usersText: "USERS PER MONTH",
      date: "Feb 2, 2025",
      title: "Myntra Studio",
      description: "How Myntra is using Influencers for its Growth",
    },
    {
      users: "15M+",
      usersText: "USERS PER MONTH",
      date: "Feb 2, 2025",
      title: "Myntra Studio",
      description: "How Myntra is using Influencers for its Growth",
    },
  ];

  return (
    <>
      <div className="influencer-container">
        {/* Hero Section */}
        <div className="influencer-hero-section d-flex align-items-center justify-content-center position-relative">
          <div className="text-center influencer-hero text-white position-absolute bottom-0 pb-4">
            <h1 className="hero-title- influencer ">
              Where Connections Ignite and Partnerships Thrive{" "}
            </h1>
            <span className="text-light">
              <hr />
            </span>
          </div>
        </div>
        {/* market */}
        <div className="container py-4">
          <h2 className="Title">
            Market Overview
          </h2>
          <Slider {...marketsettings}>
            <div className="px-2">
              <div className="bg-light rounded p-3 card">
                <h3 className="heading-title text-success fw-medium mb-2">
                  Growth
                </h3>
                <hr />
                <p className="text-muted small card-content">
                  India's influencer marketing sector is projected to reach INR
                  3,375 crore by 2025, with a CAGR of 18%.
                </p>
              </div>
            </div>

            <div className="px-2">
              <div className="bg-light rounded p-3 card">
                <h3 className="heading-title text-success fw-medium mb-2">
                  Global Market
                </h3>
                <hr />
                <p className="text-muted small card-content">
                  The global influencer marketing industry is expected to exceed
                  $24 billion by 2025.
                </p>
              </div>
            </div>

            <div className="px-2">
              <div className="bg-light rounded p-3 card">
                <h3 className="heading-title text-success fw-medium mb-2">
                  Effectiveness
                </h3>
                <hr />
                <p className="text-muted small card-content">
                  81% of marketers consider influencer marketing a highly
                  effective strategy.
                </p>
              </div>
            </div>

            <div className="px-2">
              <div className="bg-light rounded p-3 card">
                <h3 className="heading-title text-success fw-medium mb-2">
                  Budget Allocation
                </h3>
                <hr />
                <p className="text-muted small card-content">
                  Brands are now investing 40% of their digital marketing
                  budgets in influencer collaborations.
                </p>
              </div>
            </div>
          </Slider>
        </div>

        {/* slider */}
        <section className="shopify-section fresh-section__text-1 fresh-section">
          <div className="container-fluid page-width">
            <div className="row slider">
              <div className="column col-12 g-0 col-md-12 col-lg-12 col-xl-12">
                <Slider
                  {...settings}
                  className="fresh-slides example example-1"
                >
                  <div className="image-container">
                    <img src={influencerSliderUser} alt="brandGroupCarousel" />
                    <div className="d-flex">
                      {" "}
                      <div className="slider-text ps-3">
                        <div className="key-trend">Key Trends </div>
                        <div>Nano and </div> <div>Micro Influencers</div>
                      </div>
                    </div>
                  </div>
                  <div className="image-container">
                    <img
                      src={influencerSliderRobot}
                      alt="selfieBrandCarousel"
                    />
                    <div className="slider-text">
                      <div>Key Trends</div> <div>Video First</div>
                      <div>Campaigns</div>
                    </div>
                  </div>
                  <div className="image-container">
                    <img
                      src={influencerSliderComputer}
                      alt="brandgroupselfie"
                    />
                    <div className="slider-text">
                      <div> Key Trends</div> <div> Ai Driven Connections</div>
                      <div>For Better ROI</div>{" "}
                    </div>
                    <div className="slider-text"></div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </section>

        {/* MainContainerPadding For Paddign with Side space */}
        <div className="MainContainerPadding">
          <div className="brand-panel-4 mt-5 mb-5">
            <div className="row align-items-center">
              {/* Left Side: Text Content */}

              {/* Right Side: Image */}
              <div className="col-xs-12 col-sm-12 col-md-6">
                {/* <div className="brand-challenges-img"> */}
                <div className="about-image1">
                  <img
                    src={brandpanel4} // Replace with your actual image
                    alt="About us"
                    className="img-fluid"
                  />
                </div>
                {/* </div> */}
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6">
                <div>
                  <div className="heading-Challenges">
                    Challenges for Brands in Influencer Marketing
                  </div>
                </div>

                {/* Map over challenges */}
                {[
                  {
                    id: 1,
                    title: "Finding the Right Campaigns",
                    description:
                      "Influencers struggle to find the right brand collaborations.",
                  },
                  {
                    id: 2,
                    title: "Time Consuming Processes",
                    description:
                      "Managing contracts, payments & campaigns is overwhelming",
                  },
                  {
                    id: 3,
                    title: "Lack of Transparency",
                    description:
                      "Unclear expectations and delayed payments hinder trust.",
                  },
                  {
                    id: 4,
                    title: "Metrics and Insights",
                    description:
                      "Limited access to tools for showcasing value to brands.",
                  },
                  {
                    id: 5,
                    title: "Sustainability of Income",
                    description:
                      "Difficulty in securing consistent collaborations.",
                  },
                ].map((challenge) => (
                  <div
                    key={challenge.id}
                    className="d-flex align-items-center my-4 " style={{marginLeft:"-70px"}}
                  >
                    {/* Left Image */}
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={roundbrand}
                        alt="Influencer"
                        style={{
                          width: "30px",
                          height: "auto",
                          borderRadius: "8px",
                        }}
                      />
                      {/* Numeric Number */}
                      <div
                        style={{
                          color: "rgba(107, 142, 118, 1)",
                          fontFamily: "Poppins",
                          fontSize: "18px",
                          fontWeight: "600",
                          lineHeight: "30px",
                          textAlign: "left",
                          textUnderlinePosition: "from-font",
                          textDecorationSkipInk: "none",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        {challenge.id}
                      </div>
                    </div>

                    {/* Right Text */}
                    <div className="challenges-brand">
                      <div className="title-Challenges">{challenge.title}</div>
                      <p className="description-Challenges">
                        {challenge.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Influencer benefits with Insocial Orbit */}

        <div
          className="main-content py-4"
          style={{ paddingLeft: "5rem", paddingRight: "5rem" }}
        >
          <div className="MainContainerPadding">
            <div className="heading-brand-benifit">
              <div className="titles-brand">
                Influencer Benefit with Insocial Orbit
              </div>
            </div>
            <div className="all-cards row mb-5" style={{marginLeft:"-36px"}}>
              {[
                {
                  id: 1,
                  image: Growth,
                  heading: "Curated Influencer Network",
                  description:
                    "Build a professional portfolio and form long term collaborations",
                },
                {
                  id: 2,
                  image: Efficiency,
                  heading: "Data Driven Insights",
                  description:
                    "Streamlined processes for applications, contracts & payments.",
                },
                {
                  id: 3,
                  image: Metrics,
                  heading: "Scalable Campaigns",
                  description:
                    "Advanced tools to showcase your value to brands with actionable insights.",
                },
                {
                  id: 4,
                  image: Transparency,
                  heading: "Authentic Storytelling",
                  description:
                    "Secure and timely payments, whether monetary or barter.",
                },
                {
                  id: 5,
                  image: Access,
                  heading: "End to End Support",
                  description:
                    "Exclusive brand campaigns tailored to your niche.",
                },
              ].map((card) => (
                <div
                  key={card.id}
                  className="col-xs-12 col-sm-12 col-md-12 col-lg-4 text-center"
                >
                  <div className="card-one">
                    <div className="card">
                      <div className="card-content">
                        <div className="card-image">
                          <img
                            src={card.image} // Replace with your actual image
                            alt="Card Image"
                          />
                        </div>
                        <div className="brand-text-container">
                          <div className="brand-card-heading">
                            <div className="card-heading">{card.heading}</div>
                          </div>
                          <div className="brand-card-description">
                            <p className="card-description">
                              {card.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* panel-6 */}
        <div
          className="container-fluid impactful-stats"
          style={{ paddingLeft: "5rem", paddingRight: "5rem" ,marginLeft:"32px"}}
        >
          <h2 className="Title">Impactful Stats</h2>
          <div className="stats-container">
            {stats.map((stat, index) => (
              <div className="stat-card" key={index}>
                <h3 className="stat-title">{stat.title}</h3>
                <hr className="divider" />
                <div className="stats-description">
                  <p className="stat-description">{stat.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Case Studies */}

        <div className="px-4 py-12  container-fluid mb-5 " style={{marginLeft:"32px"}}>
          <div className="MainContainerPadding">
            <h2 className="text-3xl font-medium case-studies mb-8">
              Case Studies
            </h2>
            <div className="row g-4">
              {cases.map((caseStudy, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <div className=" card-case p-4 h-100">
                    <div className="mb-3 d-flex user-text">
                      <div className="text-user num  fs-3">
                        {caseStudy.users}
                      </div>
                      <div className="text-user word">
                        {caseStudy.usersText}
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      {/* <img
                      src={caseStudyy}
                      alt="Myntra Logo"
                      className="img-fluid"
                      style={{ width: "120px", height: "40px" }}
                    /> */}
                      <img
                        src={caseStudyy}
                        alt="Case Study Image"
                        className="rounded-lg"
                        style={{
                          width: "100%",
                          height: "160px",
                          objectFit: "cover",
                          borderRadius:"25px",
                        }}
                      />
                    </div>
                    <div className="date-case mb-3">{caseStudy.date}</div>
                    <h3 className="fs-4 title-case mb-3">{caseStudy.title}</h3>
                    <p className="description-case mb-3">
                      {caseStudy.description}
                    </p>
                    <div className="read-more text-center">
                      {" "}
                      <button className="read-more-btn"> Read More</button>
                    </div>
                    {/* <Button  className="read-more-btn ">
                    Read More
                  </Button> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Influencer;
